import React from 'react';
export function CalendarEmbed() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-460">
      <div className="max-w-5xl mx-auto px-4 md:px-8 pt-8" data-id="element-461">
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-462">
          <iframe src="https://calendar.google.com/calendar/embed?src=flsportsmansclub%40gmail.com&ctz=America%2FNew_York" style={{
          border: 0
        }} width="100%" height="650" frameBorder="0" scrolling="no" title="FLSC Club Calendar" data-id="element-463" />
        </div>
      </div>
    </div>;
}